var map = {
	"./pages/add-plato-to-daily-menu/add-plato-to-daily-menu.module": [
		"./src/app/pages/add-plato-to-daily-menu/add-plato-to-daily-menu.module.ts",
		"pages-add-plato-to-daily-menu-add-plato-to-daily-menu-module"
	],
	"./pages/added-stock-products/added-stock-products.module": [
		"./src/app/pages/added-stock-products/added-stock-products.module.ts",
		"pages-added-stock-products-added-stock-products-module"
	],
	"./pages/allergens/allergens.module": [
		"./src/app/pages/allergens/allergens.module.ts",
		"pages-allergens-allergens-module"
	],
	"./pages/bed-details/bed-details.module": [
		"./src/app/pages/bed-details/bed-details.module.ts",
		"pages-bed-details-bed-details-module"
	],
	"./pages/beds/beds.module": [
		"./src/app/pages/beds/beds.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"default~pages-beds-beds-module~pages-chairs-chairs-module~pages-diner-diner-module~pages-tables-tabl~298c5d71",
		"pages-beds-beds-module"
	],
	"./pages/calendar-details/calendar-details.module": [
		"./src/app/pages/calendar-details/calendar-details.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"pages-calendar-details-calendar-details-module"
	],
	"./pages/calendar-food/calendar-food.module": [
		"./src/app/pages/calendar-food/calendar-food.module.ts",
		"default~pages-calendar-calendar-module~pages-calendar-food-calendar-food-module~pages-trazabilidad-t~e6e86538",
		"pages-calendar-food-calendar-food-module"
	],
	"./pages/calendar/calendar.module": [
		"./src/app/pages/calendar/calendar.module.ts",
		"default~pages-calendar-calendar-module~pages-calendar-food-calendar-food-module~pages-trazabilidad-t~e6e86538",
		"pages-calendar-calendar-module"
	],
	"./pages/chair-details/chair-details.module": [
		"./src/app/pages/chair-details/chair-details.module.ts",
		"pages-chair-details-chair-details-module"
	],
	"./pages/chairs/chairs.module": [
		"./src/app/pages/chairs/chairs.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"default~pages-beds-beds-module~pages-chairs-chairs-module~pages-diner-diner-module~pages-tables-tabl~298c5d71",
		"pages-chairs-chairs-module"
	],
	"./pages/configuracion-plato-residencias/configuracion-plato-residencias.module": [
		"./src/app/pages/configuracion-plato-residencias/configuracion-plato-residencias.module.ts",
		"pages-configuracion-plato-residencias-configuracion-plato-residencias-module"
	],
	"./pages/daily-menu-diners/daily-menu-diners.module": [
		"./src/app/pages/daily-menu-diners/daily-menu-diners.module.ts",
		"pages-daily-menu-diners-daily-menu-diners-module"
	],
	"./pages/detalles-plato/detalles-plato.module": [
		"./src/app/pages/detalles-plato/detalles-plato.module.ts",
		"pages-detalles-plato-detalles-plato-module"
	],
	"./pages/diner-add/diner-add.module": [
		"./src/app/pages/diner-add/diner-add.module.ts",
		"pages-diner-add-diner-add-module"
	],
	"./pages/diner-edit/diner-edit.module": [
		"./src/app/pages/diner-edit/diner-edit.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"pages-diner-edit-diner-edit-module"
	],
	"./pages/diner/diner.module": [
		"./src/app/pages/diner/diner.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"default~pages-beds-beds-module~pages-chairs-chairs-module~pages-diner-diner-module~pages-tables-tabl~298c5d71",
		"pages-diner-diner-module"
	],
	"./pages/docs-download/docs-download.module": [
		"./src/app/pages/docs-download/docs-download.module.ts",
		"pages-docs-download-docs-download-module"
	],
	"./pages/docs-files/docs-files.module": [
		"./src/app/pages/docs-files/docs-files.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"pages-docs-files-docs-files-module"
	],
	"./pages/docs-folder-details/docs-folder-details.module": [
		"./src/app/pages/docs-folder-details/docs-folder-details.module.ts",
		"pages-docs-folder-details-docs-folder-details-module"
	],
	"./pages/docs-folders/docs-folders.module": [
		"./src/app/pages/docs-folders/docs-folders.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"docs-folders-docs-folders-module"
	],
	"./pages/filter/filter.module": [
		"./src/app/pages/filter/filter.module.ts",
		"pages-filter-filter-module"
	],
	"./pages/folder-years/folder-years.module": [
		"./src/app/pages/folder-years/folder-years.module.ts",
		"pages-folder-years-folder-years-module"
	],
	"./pages/ingredientes-plato/ingredientes-plato.module": [
		"./src/app/pages/ingredientes-plato/ingredientes-plato.module.ts",
		"pages-ingredientes-plato-ingredientes-plato-module"
	],
	"./pages/meal-details/meal-details.module": [
		"./src/app/pages/meal-details/meal-details.module.ts",
		"pages-meal-details-meal-details-module"
	],
	"./pages/modal-fill-task-fields/modal-fill-task-fields.module": [
		"./src/app/pages/modal-fill-task-fields/modal-fill-task-fields.module.ts"
	],
	"./pages/notifications/notifications.module": [
		"./src/app/pages/notifications/notifications.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"pages-notifications-notifications-module"
	],
	"./pages/profile-edit/profile-edit.module": [
		"./src/app/pages/profile-edit/profile-edit.module.ts",
		"profile-edit-profile-edit-module"
	],
	"./pages/select-food-by-category/select-food-by-category.module": [
		"./src/app/pages/select-food-by-category/select-food-by-category.module.ts"
	],
	"./pages/stock-edit/stock-edit.module": [
		"./src/app/pages/stock-edit/stock-edit.module.ts",
		"pages-stock-edit-stock-edit-module"
	],
	"./pages/stock/stock.module": [
		"./src/app/pages/stock/stock.module.ts",
		"pages-stock-stock-module"
	],
	"./pages/tables/tables.module": [
		"./src/app/pages/tables/tables.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"default~pages-beds-beds-module~pages-chairs-chairs-module~pages-diner-diner-module~pages-tables-tabl~298c5d71",
		"pages-tables-tables-module"
	],
	"./pages/tasks-done/tasks-done.module": [
		"./src/app/pages/tasks-done/tasks-done.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"pages-tasks-done-tasks-done-module"
	],
	"./pages/tasks/tasks.module": [
		"./src/app/pages/tasks/tasks.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"pages-tasks-tasks-module"
	],
	"./pages/trazabilidad/trazabilidad.module": [
		"./src/app/pages/trazabilidad/trazabilidad.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~pages-beds-beds-module~pages-chairs-chairs-module~pages-diner-diner-module~pages-tables-tabl~298c5d71",
		"default~pages-calendar-calendar-module~pages-calendar-food-calendar-food-module~pages-trazabilidad-t~e6e86538",
		"pages-trazabilidad-trazabilidad-module"
	],
	"./pages/upload-document/upload-document.module": [
		"./src/app/pages/upload-document/upload-document.module.ts",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~049cbff9",
		"default~docs-folders-docs-folders-module~home-home-module~pages-beds-beds-module~pages-calendar-deta~3a05caec",
		"pages-upload-document-upload-document-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;